export const PointAmount = ({ amount, signDisplay = "auto" }: { readonly amount: number; readonly signDisplay?: "auto" | "always" }) => {
  const formatted = amount.toLocaleString("ko-KR", { signDisplay })
  return (
    <span aria-label={`${formatted} 포인트`} className="cashhub-point-amount" role="img">
      <span aria-hidden="true" className="cashhub-point-symbol">
        C
      </span>
      <span aria-hidden="true">{formatted}</span>
    </span>
  )
}

// Web view responses retain their existing won-denominated contract. Only
// complete numeric amounts become CashHub points; other detail text is untouched.
const parsePointValue = (value: string): { amount: number; signDisplay: "auto" | "always" } | null => {
  const match = /^([+-]?)(\d+|\d{1,3}(?:,\d{3})+)원$/u.exec(value.trim())
  if (match === null) return null
  const amount = Number(`${match[1]}${match[2]?.replaceAll(",", "")}`)
  if (!Number.isSafeInteger(amount)) return null
  return { amount, signDisplay: match[1] === "+" ? "always" : "auto" }
}

export const pointValueLabel = (value: string): string => {
  const parsed = parsePointValue(value)
  return parsed === null ? value : `${parsed.amount.toLocaleString("ko-KR", { signDisplay: parsed.signDisplay })} 포인트`
}

export const FormattedPointAmount = ({ value }: { readonly value: string }) => {
  const parsed = parsePointValue(value)
  return parsed === null ? value : <PointAmount {...parsed} />
}
